import { BaseApi } from "../BaseApi";
import {
  AuthCredentialsBodyProps,
  LoginAdminProps,
  reGetAccessTokenBodyProps,
  userInfo,
} from "./AuthDTO";

export class AuthApi extends BaseApi {
  public getToken(body: AuthCredentialsBodyProps): Promise<LoginAdminProps> {
    return this.post("v1/auth/access-token", { json: body });
  }
  public refreshAccessToken(body: reGetAccessTokenBodyProps): Promise<LoginAdminProps> {
    return this.post("v1/auth/refresh-token", { json: body });
  }
  public getUserInfo(companyId: string, userId: string): Promise<{ data: userInfo }> {
    return this.get(`v1/companies/${companyId}/users/${userId}`);
  }
}
